var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("page-step-layout", {
    scopedSlots: _vm._u(
      [
        {
          key: "title",
          fn: function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "application-standalone.pages.properties.propertiesYouOwn"
                    )
                  ) +
                  "\n  "
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              _vm.isRefinanceOrSwitchTransfer
                ? _c("div", {
                    staticStyle: { color: "red", "margin-top": "4px" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "application-standalone.pages.properties.doNotReenterPropertiesAlreadyEntered"
                        )
                      ),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("page-toggler-layout", {
                attrs: { "show-information-page": _vm.showInformationPage },
                scopedSlots: _vm._u([
                  {
                    key: "summary",
                    fn: function () {
                      return [
                        _c("other-property-summary", {
                          attrs: { "show-errors": _vm.showErrors },
                          on: {
                            navigate: _vm.navigateToInformationPage,
                            "disable-save": function ($event) {
                              return _vm.$emit("disable-save", $event)
                            },
                            save: function ($event) {
                              return _vm.$emit("save")
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "information",
                    fn: function () {
                      return [
                        _c("other-property-information", {
                          attrs: {
                            "show-errors": _vm.showErrors,
                            "applicant-index":
                              _vm.togglerMetadata.applicantIndex,
                            "other-property-index":
                              _vm.togglerMetadata.otherPropertyIndex,
                            "applicant-id": _vm.togglerMetadata.applicantId,
                          },
                          on: { navigate: _vm.navigateToInformationPage },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "navigation",
          fn: function () {
            return [
              _vm._t("navigation-toolbar", null, null, {
                handleNavigateNext: _vm.handleNavigateNext(),
                handleNavigateBack: _vm.handleNavigateBack(),
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }